module.exports = "<p l10nTranslate>auth-success\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/auth-callback/auth-callback.component.html
// module id = ../../../../../src/app/auth-callback/auth-callback.component.html
// module chunks = 1